import 'jquery';
import 'slick-carousel';

/**
 * REST Api Schema
 * [{title: String, date: String, time: String, thumbnail: String}]
 */

function getEventCard (data) {
  let thumbnail = data.thumbnail
    ? `<div class="card-img">
        <figure class="thumbnail thumbnail-lg">
          <img class="img-fluid" src="${data.thumbnail}">
          <figcaption></figcaption>
        </figure>
      </div>`
    : ''

  let card = `
    <div class="col-12">
      <div class="card card-calendar">
        <div class="row">
          <div class="col-5 col-lg-4">
            <a href="${data.link}" title="${data.title}">
              ${thumbnail}
            </a>
          </div>
          <div class="col-7 col-lg-8">
            <div class="card-body">
              <h3 class="card-title">
                <a href="${data.link}" title="${data.title}">${data.title}</a>
              </h3>
              <small><strong>${data.date}</strong>, ${data.time}</small>
              <div class="location">
                <a class="location__badge" style="background-color: #ff600a;" href="${data.location_link}" title="${data.location_title}">${data.location_title}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>`

    return card
}


jQuery(document).ready(() => {

  let container = $('.calendar-list')
  let pagingNav = $('#pagination')

  $('.widget-calendar .calendar-months').on('init', function () {
    $("[data-slick-index='"+0+"']").find('.calendar-day.has-events').attr('tabindex', 0)
  })

  $('.widget-calendar .calendar-months').slick({
    dots: false,
    infinite: false,
    arrows: true,
    nextArrow: $('.widget-calendar .widget-slider-nav .next'),
    prevArrow: $('.widget-calendar .widget-slider-nav .prev'),
    adaptiveHeight: true,
  })

  $('.widget-calendar .calendar-months').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    $("[data-slick-index='"+nextSlide+"']").find('.calendar-day.has-events').attr('tabindex', 0)
    $("[data-slick-index='"+currentSlide+"']").find('.calendar-day.has-events').removeAttr('tabindex', 0)
  })

  $('.widget-calendar .has-events').on('click keydown', function (event) {    
    if (event.type === 'keydown' && event.originalEvent.key !== 'Enter') {
      return;
    }
    event.preventDefault()

    let date = $(this).attr('data-date')

    container.addClass('loading')
    pagingNav.css('display', 'none')

    $('.widget-calendar .day-selected').removeClass('day-selected')
    $(this).addClass('day-selected')

    $.post(
      // eslint-disable-next-line no-undef
      cal.endpoint,
      {
        // eslint-disable-next-line no-undef
        nonce: cal.nonce,
        date: date,
        // eslint-disable-next-line no-undef
        action: cal.action,
      },
      (response, status) => {
        if (status === 'success') {
          container.html("")

          for (var i = 0; i < response.data.length; i++) {
            let element = getEventCard(response.data[i])
            container.append(element)
          }
        }

        container.removeClass('loading')
      }
    )
  })
})



// WEBPACK FOOTER //
// ./scripts/calendar.js